import {
  Button,
  Grid,
  InputLabel,
} from "@mui/material";
import { Field, Formik } from "formik";
// import { connect } from 'http2';
import { connect } from "react-redux";
import FormikSelect from "../../shared/material-ui-formik/FormikSelect";
import { useTranslation } from "react-i18next";

const General = (props) => {
  const { t } = useTranslation();


  return (
    <div
      className="d-block p-2"
      style={{ background: "#fff", border: "1px solid gray" }}
    >
      <h5 className="mb-1" style={{ color: "gray" }}>
        {t("CHECK-IN TIMES")}
      </h5>
      <div className="d-flex mb-3">
        {/* <div className='d-block'> */}
        <Formik>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <InputLabel>{t("Check in time")}</InputLabel>
              <Field
                // label="Email"
                type="text"
                name="userName"
                id="userName"
                autoComplete="off"
                maxLength={150}
                component={FormikSelect}
              />
            </Grid>
            <Grid item xs={6}>
              <InputLabel>{t("Check Out time")}</InputLabel>
              <Field
                // label="Email"
                type="text"
                name="userName"
                id="userName"
                autoComplete="off"
                maxLength={150}
                component={FormikSelect}
              />
            </Grid>
          </Grid>
        </Formik>
      </div>
 
      <div className="w-100 d-flex justify-content-center">
        <Button
          className="mt-1 mr-1 comman-cancel-button"
          size="large"
          variant="contained"
          disableElevation
          color="primary"
        >
          {t("Cancel")}
        </Button>
        <Button
          className="mt-1 comman-button"
          size="large"
          variant="contained"
          disableElevation
          color="primary"
        >
          {t("Save")}
        </Button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    state: state,
  };
};

export default connect(mapStateToProps)(General);
